import * as React from 'react';
import {connect} from 'react-redux';
import {BasePage} from '../reusableComponents/BasePage';
import {Async} from '../reusableComponents/Async';
import {Loader} from '../reusableComponents/Loader/Loader';
import {ErrorPage} from '../reusableComponents/ErrorPage';
import {withRouter} from 'react-router';
import './users.scss';
import {Icon} from '../reusableComponents/Icon';
import {IFileProps} from '../Modules/FileInputComponent';
import {Table} from 'reactstrap';
import Papa from 'papaparse';
import {submitBulkUserCreation} from '../../services/userService';
import {IHistory} from '../../interfaces';

const templateFile = require('../../assets/User-Template.csv');

interface IMultipleUserCreationProps {
    history: IHistory;
}

interface IMultipleUserCreationStates {
    file: IFileProps;
    userTableData: Array<any>;
}

class MultipleUserCreationImpl extends React.Component<IMultipleUserCreationProps, IMultipleUserCreationStates> {

    constructor(props: IMultipleUserCreationProps) {
        super(props);
        this.state = {file: {fileName: '', file: null}, userTableData: []};
    }

    onFileAdded = (e) => {
        const file = {
            fileName: e.target.files[0].name,
            file: e.target.files[0]
        };
        e.target.value = null;
        this.setState({
            file
        }, () => {
            Papa.parse(this.state.file.file, {
                header: true,
                skipEmptyLines: true,
                complete: data => {
                    this.setState({
                        userTableData: data.data
                    }, () => {
                        submitBulkUserCreation(this.state.userTableData, this.props.history).then((res) => {
                            this.setState({
                                userTableData: res.data || []
                            });
                        });
                    });
                }
            });
        });
    }

    multipleUserUploadTemplate = () => {
        return <div className={'multiple-user-creator-container'}>
            <span className={'upload-information-para'}>
            <p>You can find the sample template file <a href={templateFile} download={'User-Template.csv'}>here</a></p>
            </span>
            <div className="file-input-container">
                <div className="file-input-upload">
                    <div><Icon icon="upload"/></div>
                    <div><label htmlFor="fileInput">Select File</label></div>
                    <input onChange={this.onFileAdded} type="file" id="fileInput"/>
                </div>
                <div className={'file-name-display'}>
                    <p>{this.state.file.fileName}</p>
                </div>
            </div>
            {this.state.userTableData.length > 0 && <div className={'uploaded-data-list'}>
                <Table bordered responsive>
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>ID</th>
                        <th>Email</th>
                        <th>Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        this.state.userTableData.map((user, index) => {
                            return <tr key={index + 'mu'}>
                                <th scope="row">{index + 1}</th>
                                <td>{user.Last_Name + ', ' + user.First_Name}</td>
                                <td>{user.UserId}</td>
                                <td>{user.Email}</td>
                                <td style={{textAlign: 'center'}}>{user.message === 'success' ? <span className={'fa fa-thumbs-up'}/> : <span style={{color: 'red'}}>{user.message}</span>}</td>
                            </tr>;
                        })
                    }
                    </tbody>
                </Table>
            </div>}
        </div>;
    }

    public render() {
        return <BasePage title={'Create Multiple User'} icon="user-plus">
            <Async
                identifier="CreateUser"
                promise={() => {
                    return {};
                }}
                content={this.multipleUserUploadTemplate()}
                loader={<Loader type="async"/>}
                error={<ErrorPage/>}
            />
        </BasePage>;
    }
}

function mapStateToProps() {
    return {};
}

export const MultipleUserCreation = withRouter(connect<{}, {}, IMultipleUserCreationProps>(mapStateToProps)(MultipleUserCreationImpl) as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Users/CreateMultipleUser.tsx